'use strict';
import {assetTaskReduxItem, assetTaskRouterState} from '../redux/assetTaskRouterState';
import {reduxList as assetTasksReduxList} from '../redux/assetTasks';
import {createAssetTaskRequestModal} from '../redux/createAssetTask';
import {createProjectTaskRequestModal} from '../redux/createProjectTask';
import {createTemplateTaskRequestModal} from '../redux/createTemplateTask';
import {projectTaskReduxItem, projectTaskRouterState} from '../redux/projectTaskRouterState';
import {reduxList as projectTasksReduxList} from '../redux/projectTasks';
import {templateTaskReduxItem, templateTaskRouterState} from '../redux/templateTaskRouterState';
import {reduxList as templateTasksReduxList} from '../redux/templateTasks';
import {updateAssetTaskRequestModal} from '../redux/updateAssetTask';
import {updateProjectTaskRequestModal} from '../redux/updateProjectTask';
import {updateTemplateTaskRequestModal} from '../redux/updateTemplateTask';


export const epics = [
  ...assetTaskReduxItem.epics.epics,
  ...assetTaskRouterState.epics.epics,
  ...assetTasksReduxList.epics.epics,
  ...projectTaskReduxItem.epics.epics,
  ...projectTaskRouterState.epics.epics,
  ...projectTasksReduxList.epics.epics,
  ...templateTaskReduxItem.epics.epics,
  ...templateTaskRouterState.epics.epics,
  ...templateTasksReduxList.epics.epics,
  ...createAssetTaskRequestModal.epics.epics,
  ...createProjectTaskRequestModal.epics.epics,
  ...createTemplateTaskRequestModal.epics.epics,
  ...updateAssetTaskRequestModal.epics.epics,
  ...updateProjectTaskRequestModal.epics.epics,
  ...updateTemplateTaskRequestModal.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/tasks/epics/index.js